export default defineNuxtPlugin({
  name: 'auth',
  async setup() {
    const { fetchMe } = useAuth()
    await fetchMe()
  },
})
